export type AuthPermissionsResponse = {
  permissions: string[];
  role: string;
  modules?: Record<string, boolean> | null;
  permissions_effective?: string[];
  permissions_preset?: string[];
  jit_permissions?: string[];
  modules_effective?: Record<string, boolean> | null;
  capability_version?: number;
};

export type EffectivePermissionsSnapshot = Partial<Pick<
  AuthPermissionsResponse,
  'permissions' | 'permissions_effective'
>> & {
  role?: string;
};

/**
 * Список для hasPermission: приоритет непустого `permissions_effective`, иначе legacy `permissions`.
 * Пустой массив effective не затирает непустой preset (false-negative в guard).
 */
export function permissionsListForEffectiveGuard(permissionsRaw: EffectivePermissionsSnapshot | null | undefined): string[] {
  if (!permissionsRaw) return [];
  const eff = permissionsRaw.permissions_effective;
  const legacy = permissionsRaw.permissions ?? [];
  if (Array.isArray(eff) && eff.length > 0) {
    return eff;
  }
  if (Array.isArray(eff) && eff.length === 0 && legacy.length > 0) {
    return legacy;
  }
  if (Array.isArray(eff)) {
    return eff;
  }
  return legacy;
}
